export { default } from './RoundedRectangleOutline'
